import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import ptMessages from './locales/pt-PT.json';
import enMessages from './locales/en-US.json';
import App from './App';
import { NotificationProvider } from './contexts/NotificationContext';

const messages: { [key: string]: any } = {
  'pt-PT': ptMessages,
  'en-US': enMessages,
};

const AppWrapper: React.FC = () => {
  const [locale, setLocale] = useState<'pt-PT' | 'en-US'>('en-US');

  return (
    <IntlProvider messages={messages[locale]} locale={locale}>
      <NotificationProvider>
        <App locale={locale} setLocale={setLocale} />
      </NotificationProvider>
    </IntlProvider>
  );
};

export default AppWrapper;